module.exports = __webpack_public_path__ + "static/img/zhong2.7815fd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong2.png
// module id = jKG6
// module chunks = 16